const numberToMoneyString = (value) =>
  value.toLocaleString("en-us", { style: "currency", currency: "USD" });

const moneyStringToNumber = (value) => parseFloat(value.replace("$", ""));

const toMoneyWithTwoDecimalDigits = (value) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false
  }).format(parseInt(value, 10) / 100);
};

const toMoneyWithMaximumTwoDecimalDigits = (value) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    useGrouping: false
  }).format(parseInt(value, 10) / 100);
};

const isValidIncrement = ({ increment, value }) => {
  let [dollars, cents = ""] = value.toString().split(".");
  if (cents.length === 0) {
    cents = cents + "00";
  } else if (cents.length === 1) {
    cents = cents + "0";
  }

  value = Number(`${dollars}${cents}`);

  const isValid = Number.isInteger(value / increment);

  return isValid;
};

export {
  moneyStringToNumber,
  numberToMoneyString,
  toMoneyWithTwoDecimalDigits,
  toMoneyWithMaximumTwoDecimalDigits,
  isValidIncrement
};
